import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function ProtectedRoute({ children, requireAdmin = false, requireSuperAdmin = false, requireSalonManager = false, requireWorker = false }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div className="min-h-screen bg-brandBlack flex items-center justify-center">
      <p className="text-brandWhite">Loading...</p>
    </div>;
  }

  if (!user) {
    const redirect = encodeURIComponent(`${location.pathname}${location.search}`);
    return <Navigate to={`/login?redirect=${redirect}`} replace />;
  }

  if (requireSuperAdmin && user.role !== 'super_admin') {
    return <Navigate to="/" replace />;
  }
  if (requireSalonManager && user.role !== 'shop_manager' && user.role !== 'branch_manager') {
    return <Navigate to="/" replace />;
  }
  if (requireWorker && user.role !== 'worker') {
    return <Navigate to="/" replace />;
  }
  if (requireAdmin && user.role !== 'shop_admin' && user.role !== 'super_admin' && user.role !== 'shop_manager' && user.role !== 'branch_manager') {
    return <Navigate to="/" replace />;
  }

  return children;
}
